import { GetTonePriceResponse } from "src/com/sixdee/crbtportal/core/api/tune/gettuneprice/gettonepriceresponse";
import { GetTonePriceDetailsDto } from "src/com/sixdee/crbtportal/core/dto/gettoneprice/gettonepricedetailsdto";
import { ProfileToneDto, ProfileToneDtoImpl } from "src/com/sixdee/crbtportal/core/dto/profiletune/profiletonedto";
import { ToneDto } from "src/com/sixdee/crbtportal/core/dto/tonedto";
import { APIFeatures } from "src/com/sixdee/crbtportal/core/util/apifeatures";
import { BaseContext } from "src/com/sixdee/crbtportal/utils/basecontext";
import { Strings } from "src/com/sixdee/crbtportal/utils/resources/strings";
import { AlertType } from "../../../toolkit/alert/alerttype";
import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState } from "../../../toolkit/uicomponent";
import { APIModel, APIModelHandler } from "../../../toolkit/uicomponentapimodel";
import { UIComponentCSSStyle } from "../../../toolkit/uicomponentcss";
import { UIComponentView } from "../../../toolkit/uicomponentview";
import { RoutingFeatures } from "../../navigation/routingfeature";
import { GetPackDetails } from "../getpackdetails";
import { PopUpWrapperComponent } from "../popupwrappercomponent";
import { ToneOptionsType } from "../tonedetailspopup/tonedetailspopupcomponent";
import { ProfileToneAPIModelImpl } from "./profiletoneapimodel";
import { ProfileToneCSSStyleImpl } from "./profiletonecss";
import { ProfileToneViewImpl } from "./profiletoneview";


export interface ProfileToneComponentProps extends UIComponentProps
{
    toneOptionsType: ToneOptionsType;
    toneDto: ToneDto;
    getPopupWrapper():PopUpWrapperComponent|any;
    closePopup(): void;
    showPopup(id:any,msg:string,type:AlertType):void;
}

export interface ProfileToneComponentState extends  UIComponentState
{
    isPrice: boolean;
    price:string;
    packName: string;
    msisdn: string;
    isNewUser:boolean;
}

export interface ProfileToneComponentHandler extends UIComponentHandler
{
    onConfirmClick(startDate:string, startTime:string, endDate:string, endTime:string): void;
}

export class ProfileToneComponent extends UIComponentImpl<ProfileToneComponentProps, ProfileToneComponentState, ProfileToneDto> 
implements ProfileToneComponentHandler
{
    constructor(props: ProfileToneComponentProps, state:ProfileToneComponentState)
    {
        super(props);
        this.state={price:this.getContext().getUserContext().getIsLoggedIn() ? '' : 
        this.getContext().getResources().getString(Strings.gift_default_value),
         packName: this.getContext().getConfigurationSettings().getPropertyBasedOnLanguage("PACKNAME"), isPrice: false, msisdn: "",isNewUser:false};
    }

    componentDidMount()
    {
        
        if(this.getContext().getUserContext().getIsLoggedIn())
        {
            (this.getView() as ProfileToneViewImpl).showLoader();   
            (this.getAPIModel() as ProfileToneAPIModelImpl).getTonePrice(this.props.toneDto);
        }
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<ProfileToneDto>
    {
        return new ProfileToneViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new ProfileToneCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new ProfileToneAPIModelImpl(applicationContext, apiModelHandler);
    }

    onConfirmClick(startDate:string, startTime:string, endDate:string, endTime:string): void
    {
        console.log("onConfirmClick1");

        if(this.getContext().getUserContext().getIsLoggedIn())
        {
            console.log("onConfirmClick2" + this.state.isNewUser);

            if(this.state.isNewUser)
            {
                (this.props.context.getUserContext().setMsisdnB(this.getContext().getUserContext().getMsisdn()));
                this.props.context.setUserContext(this.props.context.getUserContext());

                let data = new ProfileToneDtoImpl();

                data.setStartDate(startDate);
                data.setEndDate(endDate);
                data.setStartTime(startTime);
                data.setEndTime(endTime);

                this.props.showPopup(data,Strings.subscription_plan,AlertType.AUTHENTICATE);
            }
            else
            {
            (this.getView() as ProfileToneViewImpl).showLoader();  
            let data = new ProfileToneDtoImpl();
            data.setToneId(this.props.toneDto.getId());
            data.setToneName(this.props.toneDto.getToneName());
            data.setUserName(this.props.context.getUserContext().getUsername());
            data.setChannel(this.props.context.getUserContext().getChannelId());
            data.setMsisdn(this.props.context.getUserContext().getMsisdn());
            data.setLanguage(this.props.context.getUserContext().getLanguage());
            data.setPackName(this.state.packName);

            data.setStartDate(startDate);
            data.setEndDate(endDate);
            data.setStartTime(startTime);
            data.setEndTime(endTime);
            

            (this.getAPIModel() as ProfileToneAPIModelImpl).setStatusTone(data);
        }
    }
        else 
        {
            /* if((this.getView() as ProfileToneViewImpl).validate())
            {
              (this.getView() as ProfileToneViewImpl).showLoader();  
            //   (this.getAPIModel() as ProfileToneAPIModelImpl).getTonePriceNonLoggedInuser((this.getView() as ProfileToneViewImpl).getData());
            }  */
            
            this.props.context.getRedirectionHandler().routeNextFeature(RoutingFeatures.LOGIN, false);
        }
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        if(feature === APIFeatures.GET_TONE_PRICE)
        {
            (this.getView() as ProfileToneViewImpl).dismissLoader();  
            let packDetails = this.props.context.getConfigurationSettings().getPropertyBasedOnLanguage("VALIDITY");
            
            console.log("packdetails: " + packDetails);
      
        
            let PRICE_TEXT: string = new GetPackDetails(packDetails)
            .getPrice((data as GetTonePriceDetailsDto).getPackName(),
            (data as GetTonePriceDetailsDto).getPrice());
             console.log("-----tigerPRICE_TEXT: " + PRICE_TEXT +", packName: " + (data as GetTonePriceDetailsDto).getPackName());
             this.setState({price:PRICE_TEXT, msisdn: description, isPrice: true, packName: (data as GetTonePriceDetailsDto).getPackName()});
             this.setState({isNewUser:(data as GetTonePriceDetailsDto).getIsNewUser()});
             console.log("get tone price on buy now:",this.state.packName);
        }
        else if(feature === APIFeatures.BUY_TONE)
        {
            (this.getView() as ProfileToneViewImpl).dismissLoader();  
            this.props.context.getUserContext().setPackName(this.state.packName);
            this.props.context.setUserContext(this.props.context.getUserContext());
            this.props.showPopup(this.getContext().getResources().getString(Strings.your_order_is_successfully_completed),Strings.profile_tunes,AlertType.SUCCESS);   
        }
    }
    
    onFailure(feature: APIFeatures, description: string, data: any): void 
    {

        console.log(" ---------------------------- feature : "+feature);
        
        (this.getView() as ProfileToneViewImpl).dismissLoader();  
        if(feature === APIFeatures.BUY_TONE)
        {
            this.props.showPopup(description,Strings.profile_tunes,AlertType.ERROR);   

        }
        else
        {
            if((data as GetTonePriceResponse).getGetTonePriceDto().getStatusCode()+"" === "400" ){
                /* (this.getView() as ProfileToneViewImpl).dismissLoader();  
                let packDetails = this.props.context.getConfigurationSettings().getPropertyBasedOnLanguage("VALIDITY");
                
                console.log("packdetails: " + packDetails);
          
            
                let PRICE_TEXT: string = new GetPackDetails(packDetails)
                .getPrice((data as GetTonePriceDetailsDto).getPackName(),
                (data as GetTonePriceDetailsDto).getPrice());
                 console.log("-----tigerPRICE_TEXT: " + PRICE_TEXT +", packName: " + (data as GetTonePriceDetailsDto).getPackName());
                 this.setState({price:PRICE_TEXT, msisdn: description, isPrice: true, packName: (data as GetTonePriceDetailsDto).getPackName()});
                 this.setState({isNewUser:(data as GetTonePriceDetailsDto).getIsNewUser()});
                 console.log("get tone price on buy now:",this.state.packName); */
            }
            else
            {
            this.props.showPopup(description,Strings.profile_tunes,AlertType.ERROR);   
            }
        }
    }  
        
            
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/profiletone/profiletonecomponent.tsx